import translate from '../../../../scripts/core/tools/translate';
import environment from '../../../../scripts/environment';

export class UnapprovedStoresFactory {
    constructor({options, currentMap}){
        this.options = options;
        this.currentMap = currentMap;
    }

    getData() {
        const groups = environment.get('CONFIG.FILTERS.GROUPS_NAME_UNAPPROVED_STORE');
        const ufs = environment.get('CONFIG.STATES');
        const typeStores = environment.get('CONFIG.FILTERS.TYPE_OF_UNAPPROVED_STORES');

        return [
            {
                name: 'state',
                position: 1,
                data: ufs,
                fields: [
                    {
                        title: translate('UF'),
                        name: 'state',
                        value: 'value',
                        text: 'text',
                        type: 'multiselect',
                        skipAll: true,
                        orderBy: "text"
                    }
                ]
            },
            {
                name: 'typeStores',
                position: 2,
                data: typeStores,
                fields: [
                    {
                        title: `${translate('Common.Tipo')} ${translate('Common.Loja')}`,
                        name: 'typeStores',
                        value: 'id',
                        text: 'name',
                        type: 'multiselect',
                        skipAll: true,
                        orderBy: "name"
                    }
                ]
            },
            {
                name: 'group',
                position: 3,
                data: groups,
                fields: [
                    {
                        title: translate('Common.Group'),
                        name: 'group',
                        value: 'value',
                        text: 'text',
                        type: 'multiselect',
                        skipAll: true,
                        orderBy: "text"
                    }
                ]
            }
        ];
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/unapprovedStores.factory.js